






























































import { Vue, Component } from "vue-property-decorator";
import { User } from "@/components/User";

@Component
export default class UserConfirm extends Vue {
  errorMessage:string = null;
  username:string = null;
  type:string = null;
  email:string = null;

  get SelectedApp() : string {
    return this.$store.getters.SelectedApp;
  };

  set SelectedApp(app:string) {
    this.$store.commit('notifyChange', {
      SelectedApp: app
    });
  };

  get User() : User {
    return this.$store.getters.User;
  }

  async created() {
    let type = this.getURLParameter('t');
    try {
      let data = await this.User.requestResource('user/confirmemail','PUT', {
        c: this.getURLParameter('c'),
        t: type
      });
      let user:User = new User({
        GivenName: data.name,
        Surname: data.surname
      });
      this.type = type;
      this.username = user.FullName;
      this.email = data.email;
    } catch (error) {
      this.type = 'error';
      this.errorMessage = error.message || 'Email confirmation error';
      console.log(this.errorMessage);
    }
  }

  getURLParameter(name:string) : string {
    let value = RegExp(name + '=(.+?)(&|$)').exec(location.search);
    return value ? decodeURI(value[1]) : null;
  }
}
